/**
 * @file 範例服務 API
 * @description 提供範例用的 API 方法模板，供開發參考使用
 */
import { get, post } from './sub_services/base';
import config from 'config/config';
import apiPath from './api.path';
import ExceptionHandleService from 'utils/exceptionHandler';

const _EHS = new ExceptionHandleService({
  _NAME: 'service/template.ts',
  _NOTICE: 'template api'
});

/** [GET]範例 */
const getTemplate = async (): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${apiPath.template.getTemplate}`;
    const result = await get(url);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'template', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

/** [POST]範例 */
const postTemplate = async (params: Record<string, unknown>): Promise<unknown> => {
  try {
    const url = `${config.SERVER_POINT}${(apiPath.template as Record<string, string>).postTemplate}`;
    const result = await post(url, params);
    return result;
  } catch (error) {
    _EHS.errorReport(error, 'postTemplate', _EHS._LEVEL.ERROR);
    return Promise.reject(error);
  }
};

export default {
  getTemplate,
  postTemplate
};
